import { format } from "date-fns"

/**
 * Format PAF summary dates (`paf_added_date`, `reactivated_date`) for display as MM/dd/yyyy.
 * APIs often return Unix time in **seconds**; `new Date(seconds)` is wrong in JS (expects ms) and shows ~1970.
 * Matches Angular `date` pipe behavior when the backend sends numeric timestamps.
 */
export function formatPafSummaryDate(value: unknown): string {
  if (value == null || value === "") return ""

  if (typeof value === "number" && Number.isFinite(value)) {
    const n = value
    const len = String(Math.trunc(Math.abs(n))).length
    const ms = len <= 10 ? n * 1000 : n
    const d = new Date(ms)
    return isNaN(d.getTime()) ? "" : format(d, "MM/dd/yyyy")
  }

  if (typeof value === "string") {
    const t = value.trim()
    if (!t) return ""
    if (/^\d+$/.test(t)) {
      return formatPafSummaryDate(Number(t))
    }
    const d = t.includes(" ") ? new Date(t.replace(" ", "T")) : new Date(t)
    return isNaN(d.getTime()) ? "" : format(d, "MM/dd/yyyy")
  }

  return ""
}
